import React, { Suspense, useCallback, useEffect } from 'react';
import { Route } from 'react-router';
import { Spinner, SpinnerSize } from '@fluentui/react';
import { ErrorPage404, Layout } from 'common';
import { WaitForInitialization } from 'common/WaitForInitialization';
import { screenSizeChanged, useAppDispatch } from 'store';

const Loading = () => <Spinner size={SpinnerSize.large} style={{ flex: 1 }} />;

export const UnauthenticatedApp = (): JSX.Element => {
  const dispatch = useAppDispatch();

  const onResize = useCallback((): void => {
    dispatch(screenSizeChanged());
  }, [dispatch]);

  useEffect(() => {
    window.addEventListener('resize', onResize);
  }, [dispatch, onResize]);

  return (
    <WaitForInitialization fallback={<Loading />}>
      <Layout>
        <Suspense fallback={<Loading />}>
          <Route component={ErrorPage404} />
        </Suspense>
      </Layout>
    </WaitForInitialization>
  );
};

export default UnauthenticatedApp;
